export function buildGuestListenUrl(listenUrl) {
  return listenUrl || '';
}

export function expoCsvFilename(eventName, date = new Date()) {
  const event = (eventName || 'all').replace(/[^a-zA-Z0-9_-]/g, '-');
  return `ltbb-expo-emails-${event}-${date.toISOString().slice(0, 10)}.csv`;
}
